export default class ActiveDirectoryHelper {

	public static extractAdToken(rawData: string): string | null {
		const part = rawData.match('id_token=(.+?)&');
		return part !== null ? part[1] : null;
	}

}
